export default __webpack_public_path__ + "static/media/personalization.a7646583.svg";